/**
 * TEMPORARY dev-only override for `permissions.allow_all_network_egress` on
 * outgoing wb_agent turns. No UI surface — set via the browser console:
 *
 *     window.__WB_AGENT_SET_ALLOW_ALL_NETWORK_EGRESS(true);       // explicit on
 *     window.__WB_AGENT_SET_ALLOW_ALL_NETWORK_EGRESS(false);      // explicit off
 *     window.__WB_AGENT_SET_ALLOW_ALL_NETWORK_EGRESS(undefined);  // clear (inherit)
 *
 * Three states match the backend: `true` and `false` are explicit overrides
 * that propagate to descendants; `undefined` omits the field so the backend
 * inherits from the parent turn (or its default).
 *
 * State is sticky and in-memory only — survives across turns within a tab,
 * resets on reload. Delete this file to remove the feature.
 */

import type {components} from '@wandb/weave/lib/WbAgent/generated/wb-agent-types';

type TurnPermissionsPatch = components['schemas']['TurnPermissionsPatch'];

let _allowAllNetworkEgress: boolean | undefined = undefined;

if (typeof window !== 'undefined') {
  (
    window as unknown as Record<string, unknown>
  ).__WB_AGENT_SET_ALLOW_ALL_NETWORK_EGRESS = (
    value: boolean | undefined
  ): void => {
    _allowAllNetworkEgress = value;
    // eslint-disable-next-line no-console
    console.warn('[wb-agent] allow_all_network_egress override =', value);
  };
}

/**
 * Returns the patch to send on the next `POST /turns`, or `undefined` to
 * omit the `permissions` field entirely (so the backend inherits).
 */
export function getNextTurnPermissions(): TurnPermissionsPatch | undefined {
  if (_allowAllNetworkEgress === undefined) {
    return undefined;
  }
  return {allow_all_network_egress: _allowAllNetworkEgress};
}
